/* eslint-disable no-unused-vars */
import { Typography } from '@mui/material';
import SectionLayout from 'components/common/SectionLayout';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  generalActions,
  targetingPlacementsActions,
  targetingBrandsModelsActions,
  formErrorsCampaign_action,
  creativesActions,
} from 'store/actions';
import { ErrorMarker } from 'assets/icons';
import * as S from './GeneralSection.styled';
import { RadioBox } from 'components';
import { elementIsDisabled } from 'utils';

const getValueIsOnBoarding = (isOnBoarding) => {
  if (typeof isOnBoarding === 'string') return false;
  return isOnBoarding;
};

const getValueIsOnGoing = (isOnBoarding) => {
  if (typeof isOnBoarding === 'string') return false;
  return !isOnBoarding;
};
//This component is used in CampaignMain, but it is disabled.
function CampaignType({ environment }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const targetingBrandModelType = useSelector((state) => state.targetingBrandsModels.type);

  const errorFlag = useSelector((state) => state.formErrorsCampaign.campaign_type);
  const isOnBoarding = useSelector(
    (state) => state.general.mainCampaignObject?.currentCampaignObj?.isOnBoarding,
  );
  const handleCampaignTypeChange = (e) => {
    if (e === isOnBoarding) return;
    dispatch(generalActions.changeCampaignTypeAction(e));
    dispatch(creativesActions.resetTrackingAndCreative());
    dispatch(targetingPlacementsActions.changeTab(e ? 'locations_languages' : 'placements'));
    e &&
      targetingBrandModelType !== 'all_brands' &&
      dispatch(targetingBrandsModelsActions.changeBrandsModelsTargetingType('all_brands'));
    errorFlag &&
      dispatch(
        formErrorsCampaign_action.updateErrorField({
          errorField: 'campaign_type',
          newValue: false,
        }),
      );
  };

  return (
    <>
      <SectionLayout
        noSeparator={false}
        topPadding={'0'}
        leftSide={
          <Typography variant='subtitle2' component='h6'>
            {t('campaign.general_information.type.label')}:
          </Typography>
        }
        rightSide={
          <>
            <S.GeneralContainer showBorder={errorFlag}>
              <RadioBox.CustomWithDesc
                style={{ borderRadius: '4px' }}
                disabled={elementIsDisabled(environment, getValueIsOnBoarding(isOnBoarding))}
                label='Onboarding campaign'
                variant='left'
                height={96}
                value={true}
                pressed={getValueIsOnBoarding(isOnBoarding)}
                onChange={handleCampaignTypeChange}
                desc='Campaigns that are targeting only onboarding placements (such as OOBE).'
              />
              <RadioBox.CustomWithDesc
                style={{ borderRadius: '4px' }}
                disabled={elementIsDisabled(environment, getValueIsOnGoing(isOnBoarding))}
                label='Ongoing Campaign'
                variant='right'
                height={96}
                value={false}
                pressed={getValueIsOnGoing(isOnBoarding)}
                onChange={handleCampaignTypeChange}
                desc='Campaigns that are targeting continuous placements.'
              />
            </S.GeneralContainer>
            {errorFlag && (
              <S.ErrorWrap>
                <ErrorMarker />
                <span>Please choose Campaign type.</span>
              </S.ErrorWrap>
            )}
          </>
        }
      />
    </>
  );
}

export default CampaignType;
